import { ServiceDomain } from '../../../../insights/types/InsightsTypes';
import { MyApp } from '../../../types/myAppTypes';
import {
  BaseApplicationProperty,
  MutationStatus,
  UpdateApplicationMutationResult,
  UpdateApplicationsQuery,
} from './BaseApplicationProperty';
import { DocumentNode } from 'graphql/index';

/**
 * This class is responsible for managing the Service Domain property of the application
 * @implements {BaseApplicationProperty} - This class implements the BaseApplicationProperty interface
 */
export class ServiceDomainProperty implements BaseApplicationProperty {
  field: string;
  value?: ServiceDomain;
  label: string = 'Domain';

  /**
   * This constructor initializes the field property
   * @param field - The field property
   */
  constructor(field: string) {
    this.field = field;
  }

  /**
   * This method sets the value of the property
   * @param value - The value to set
   */
  set(value: ServiceDomain) {
    this.value = value;
  }

  /**
   * This method returns the input object for the mutation
   */
  propertyMutationInput() {
    return {
      serviceDomain: this.value?.id,
    };
  }

  /**
   * This method returns the current display value of the property
   * @param app - The application object
   */
  getCurrentDisplayValue(app: MyApp): string {
    return app.serviceDomain;
  }

  /**
   * This method returns the new display value of the property
   */
  getNewDisplayValue(): string {
    return `${this.value?.name}`;
  }

  /**
   * This method returns the mutation query
   */
  mutationQuery(): DocumentNode {
    return UpdateApplicationsQuery;
  }

  /**
   * This method returns the mutation result
   * @param data - The result data from the update application mutation
   */
  getMutationResult(data: UpdateApplicationMutationResult): MutationStatus[] {
    return data?.resources?.application?.updateApplications;
  }
}
